import axios from 'axios';
import base from './apiBase';
async function request(method, path, data) {
    try { return (await axios({ method, url: base + '/payments' + path, data, withCredentials: true })).data; }
    catch (error) { throw new Error(error.response?.data?.message || 'Unable to load payments. Please try again.'); }
}
export const paymentsApi = {
    manual: async (opportunityId, lineId, amount) => {
        try { return (await axios.patch(base + '/lines/payment/' + opportunityId + '/' + lineId, { amount }, { withCredentials: true })).data; }
        catch (error) { throw new Error(error.response?.data?.message || 'Unable to save payment.'); }
    },
    settings: () => request('get', '/settings'),
    connect: () => request('post', '/connect'),
    revenue: id => request('get', '/opportunities/' + id),
    details: (id, lineId) => request('get', '/quotes/' + id + (lineId ? '?lineId=' + encodeURIComponent(lineId) : '')),
    send: (id, data) => request('post', '/quotes/' + id + '/request', data),
    action: (id, action) => request('post', '/requests/' + id + '/' + action),
};
